/**
 * Theme Inline JavaScript - Moved from theme.liquid for better performance
 * Contains critical functionality that was previously inline
 */

/**
 * Theme JavaScript - Main functionality
 * Handles cart page redirection, search drawer toggle, and product variant availability
 */
$(document).ready(function() {

  /**
   * Cart Page Redirect Handler
   * Redirects users away from cart page to home page
   * This prevents direct access to the cart page
   
    if ($('.main_cart_page').length > 0) {
      window.location.href = '/';
    }
  */

  /**
   * Search Drawer Open Handler
   * Opens the predictive search drawer when header search input is clicked.
   * 10/2026: vorher wurde hier umgeschaltet (auf/zu). Da sections/header.liquid das
   * Suchfenster beim selben Klick bereits oeffnet, hat dieses Umschalten es sofort
   * wieder geschlossen -> mobile Suche liess sich nicht oeffnen. Jetzt nur noch oeffnen.
   */
  $('.header_input_click').on('click', function() {
    $('predictive-search-drawer').attr('open', 'true');
  });

});

/**
 * Product Variant Change Handler
 * Listens for variant changes and updates UI based on availability
 * Shows/hides buy buttons and payment icons based on stock status
 */
document.addEventListener('variant:changed', function(event) {
  const variant = event.detail.variant;

  if (!variant) {
    return;
  }

  // Cache jQuery selectors for better performance
  const $buyButtons = $('.product-form__buy-buttons');
  const $paymentIcons = $('.product-form .footer_payment_icon');
  const $payTextIcon = $('.product-form .pay_text_icon');
  const $outOfStockForm = $('.main_out_form');

  if (!variant.available) {
    // Product is out of stock - hide purchase options and show out of stock form
    $buyButtons.hide();
    $paymentIcons.hide();
    $payTextIcon.hide();
    $outOfStockForm.show();
  } else {
    // Product is available - show purchase options and hide out of stock form
    $buyButtons.show();
    $paymentIcons.show();
    $payTextIcon.show();
    $outOfStockForm.hide();
  }
});

/**
 * Navigation Drawer Animation Handler
 * Adds animation classes to Weglot language switcher when navigation drawer is opened/closed
 */
$(document).ready(function() {

  // Cache selectors for better performance
  const $weglotContainer = $('.weglot-container');
  const animationClass = 'appear-animation appear-delay-11';

  /**
   * Handle hamburger menu click
   * Triggers animation when navigation drawer is opened
   */
  $('.js-drawer-open-nav svg.icon.icon-hamburger').on('click', function() {
    $weglotContainer.addClass(animationClass);
  });

  /**
   * Handle drawer close button click
   * Triggers animation when navigation drawer is closed
   */
  $('.drawer__close-button .icon').on('click', function() {
    $weglotContainer.addClass(animationClass);
  });

});
